import React from "react";

import svg from "../../assets/images/icons/search-gray.svg";

export const SearchGrayIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Search"}
    />
);
